var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gongde-guide" }, [
    _c("div", { staticClass: "back-btn", on: { click: _vm.handleBack } }, [
      _c("img", {
        attrs: {
          src: "https://fe-img.tengzhihh.com/image/bcef926966c12975fbb7e54c43d4cdeb-60x60.png",
          alt: "",
        },
      }),
    ]),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "gongde-guide-content" }, [
      _c("div", { staticClass: "title" }, [_vm._v("功德箱说明：")]),
      _vm._v(
        " 1、功德箱，又称“福田箱”，往里放钱是供养三宝、广种福田的一种方式。 "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        " 2、功德箱的意义有三：一是培养福报，二是助修行，三是促进佛法流通。 "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        " 3、提示：充值比例是1:7，举例，1元可获得7福德值。同时，只能支付整数数额。 "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        " 4、补充说明：捐献功德箱的订单不赠送用户在灵机产品下任意消费的第二日功德礼包。 "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }